<template>
    <div v-if="feedbackDialogVisible" id="RateFeedback" class="feedback-dialog">
      <div class="feedback-dialog-head">
        <i class="el-icon-close" @click="feedbackDialogClose" />
      </div>
      <div v-if="main">
        <span>您对共享云盘的满意程度如何?</span>
        <el-rate v-model="feedbackRate" :allow-half="true" class="feedback-rate" @change="rateChanged"></el-rate>
        <div v-show="feedbackDescriptionShow" class="feedback-description">
          <span v-if="feedbackRate <= 3">请描述您遇到的问题：</span>
          <span v-else>您对我们还有哪些期待？</span>
          <el-input
              type="textarea"
              :rows="3"
              v-model="feedbackDescription"
              class="feedback-description-input">
          </el-input>
        </div>
        <div class="feedback-dialog-bottom">
          <span class="error-tips" v-show="feedbackRateEmpty">请打分后再提交</span>
          <el-button type="primary" :loading="commitLoading" @click="commitFeedback">提交</el-button>
        </div>
      </div>
      <div v-if="feedbackEndDialog" class="feedback-end-dialog" >
        <div>感谢您的反馈。</div>
      </div>
    </div>
  </template>
  
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'RateFeedback',
  props: {
    title: {
      type: String,
      default: '共享云盘'
    },
    type: {
      type: Number,
      default: 8
    },
  },
  data() {
    return {
      feedbackRate: 0,
      feedbackDescription: '',
      feedbackRateEmpty: false,
      feedbackEndDialog: false,
      commitLoading: false,
      main: true,
      feedbackDescriptionShow: false,
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user',
      feedbackDialogVisible: 'feedback/feedbackDialogVisible',
    })
  },
  created() {
  },
  methods: {
    ...mapActions({
      loadUserInfo: 'user/loadUserInfo',
    }),
    rateChanged() {
      if (!this.feedbackDescriptionShow) {
        this.feedbackDescriptionShow = this.feedbackRate
      }
    },
    async commitFeedback() {
      if (!this.feedbackRate) {
        this.feedbackRateEmpty = true
        return
      }
      const feedBack = {
        title: this.title + ' ' + this.feedbackRate,
        description: this.feedbackDescription ? this.feedbackDescription : '无',
        type: this.type
      }
      if (!this.user.mobile) {
        await this.loadUserInfo()
      }
      if (this.user && this.user.mobile) {
        feedBack.mobile = this.user.mobile
      }
      this.commitLoading = true
      await this.$api.global.feedback(feedBack)
      this.feedbackRate = 0
      this.feedbackDescription = ''
      this.main = false
      this.commitLoading = false
      this.feedbackEndDialog = true
      setTimeout(() => {
        this.$emit('close')
        this.feedbackEndDialog = false
        this.main = true
        this.feedbackDescriptionShow = false
      }, 3000)
    },
    feedbackDialogClose() {
      this.$emit('close')
      this.feedbackRate = 0
      this.feedbackDescription = ''
      this.feedbackRateEmpty = false
      this.feedbackEndDialog = false
      this.main = true
      this.feedbackDescriptionShow = false
    },
  },
}
</script>
  
  <style lang="less" scoped>
    #RateFeedback{
      /deep/ .el-rate__icon{
        font-size: 24px;
        color: #ffffff;
      }
    }
    .feedback-dialog{
      position: fixed;
      width: 280px;
      border-radius: 4px;
      top: 45px;
      right: 18px;
      background: #ffffff;
      border: 1px solid @theme-color;
      box-shadow: 0 0 4px 2px rgba(0,0,0,.25);
      padding: 8px 16px;
      z-index: 999;
  
      .feedback-dialog-head{
        height: 15px;
        text-align: right;
        margin-bottom: 8px;
        .el-icon-close{
          margin-top: 5px;
          cursor: pointer;
        }
      }
  
      .feedback-rate{
        margin-top: 8px;
        margin-left: 8px;
      }
  
      .feedback-description{
        margin-top: 16px;
  
        .feedback-description-input{
          margin-top: 8px;
        }
      }
  
      .feedback-dialog-bottom{
        display: flex;
        margin-top: 16px;
        justify-content: flex-end;
        vertical-align: center;
  
        .error-tips{
          color: #F56C6C;
          margin-right: 10px;
          background-color: #FFEDED;
          white-space: nowrap;
          padding: 5px 10px;
        }
      }
  
      .feedback-end-dialog{
        padding-bottom: 30px;
      }
  
    }
  </style>
